import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Row from '../../components/Row'
import Text from '../../components/Text'

const Box = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: calc(6rem + 1vw);
  flex-shrink: 0;
  
  @media print {
    margin: -0.5rem;
  }
`

const Image = styled.img`
  height: 5rem;
  
  @media print {
    height: 3rem;
  }
`

const Eye = styled.i`
  color: #000;
  opacity: ${props => props.active ? '1' : '0.25'};
  font-size: 1rem;
  margin-top: 0.5rem;
  &:first-child {
    margin-right: 0.25rem;
  }
`

const EyeLabel = styled.div`
  text-align: center;
  margin-top: 0.5rem;
  align-self: stretch;
  flex-shrink: 0;
  font-size: 1.2rem;
  font-weight: 500;
  
  @media print {
    margin: 0;
    font-size: 0.75rem;
  }
`

const MedicationLabel = styled.div`
  font-weight: 300;
  text-align: center;
  flex-shrink: 0;
  font-size: 1.1rem;
  margin-top: 0.25rem;
  
  @media print {
    margin: 0;
    font-size: 0.75rem;
  }
`

function renderEyes(eye) {
  return (
    <Fragment>
      
    </Fragment>
  )
}

export default class Medication extends Component {
  render() {
    const { medication } = this.props
    const { eye, prescription } = medication

    return (
      <Box>
        <Image alt="" src={`/images/medications/${prescription}.png`} />
        <Row alignCenter smallMargin justifyCenter>
          <Eye className="fas fa-eye" active={eye === 'LEFT' || eye === 'BOTH'} />
          <Eye className="fas fa-eye" active={eye === 'RIGHT' || eye === 'BOTH'} />
        </Row>
        <EyeLabel>
          <Text str={`choices.eye.${eye}`} />
        </EyeLabel>
        <MedicationLabel>
          <Text str={`choices.medication.${prescription}`} />
        </MedicationLabel>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/Medication.js